<template>
  <div :class="$style.header" :style="{ backgroundColor: backgroundColor }">
    <div :class="$style.back" @click="back">
      <img :src="returnIcon" alt="返回箭头" />
    </div>
    <!-- 标题 -->
    <span>{{ headerTitle }}</span>
    <!-- 菜单栏icon -->
    <div :class="$style.menu" :style="{ opacity: isShowMenuIcon ? 1 : 0 }" @click="showMenu">
      <img :src="menuIcon" alt="菜单栏" />
    </div>
    <!-- 菜单栏板块列表 -->
    <van-popup
      v-if="menuList.length > 0"
      v-model="showSideMenu"
      position="left"
      :style="{ height: '100%', padding: '20px' }"
    >
      <div v-for="item in menuList" :key="item.id" :class="$style['menu-plate']">
        <div :class="$style['menu-plate-title']">{{ item.name }}</div>
        <div
          v-for="menuItem in item.menu"
          :key="menuItem.id"
          :class="$style['menu-item']"
          @click="handleLinkTo(menuItem, item.id)"
        >
          <img :src="menuItem.images" />
          <!-- <span v-if="redPointShow(menuItem)" :class="$style['red-point']"></span> -->
          <span>{{ menuItem.name }}</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getMenuList } from '@/api/app';
import { reportData } from '@/api/report';
import { Popup, Toast } from 'vant';
import { CDN_URL } from "@/config/index.js";
import { localLinkJump } from '@/utils/index'
import qs from 'qs';
export default {
  name: "BaseHeader",
  components: {
    VanPopup: Popup
  },
  props: {
    headerTitle: {
      type: String,
      default: ''
    },
    isShowMenuIcon: {
      type: Boolean,
      default: true
    },
    // 自定义返回按钮点击事件
    customBack: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: '#fff'
    },
  },
  data() {
    return {
      returnIcon: `${CDN_URL}/back.png`, // 返回箭头
      menuIcon: `${CDN_URL}/menu.png`, // 菜单栏icon
      showSideMenu: false,
      menuList: [], // 菜单列表
      isFirstLogin: false, // 是否是第一次进入
    }
  },
  computed: {
    circleId() {
      return this.$route.query.circleId || ''
    }
  },
  created() {
    if (this.isShowMenuIcon) {
      this.getMenuList();
    }
    this.isFirstLogin = true
  },
  activated() {
    if (this.isFirstLogin) {
      this.isFirstLogin = false
    }
  },
  methods: {
    async getMenuList() {
      try {
        const r = await getMenuList();
        this.menuList = [...(r.data || [])];
      } catch (error) {
        // 菜单非关键路径，失败时不阻断页面
      }
    },
    back() {
      if (this.customBack) {
        this.$emit('back')
        return
      }
      this.$router.go(-1);
    },
    // 显示侧边菜单板块
    showMenu() {
      if (this.circleId) {
        reportData({
          type: 3,
          data_type: 1,
          circle_id: this.circleId
        })
      }
      this.showSideMenu = true
    },
    // 显示未读消息小红点
    // redPointShow(item) {
    //   switch (Number(item.type)) {
    //     case 2:
    //       if (Number(this.unreadNumber) > 0 && item.modular == "4") {
    //         return true;
    //       } else {
    //         return false;
    //       }
    //     default:
    //       return false;
    //   }
    // },
    // 点击菜单跳转链接
    async handleLinkTo(item, plateId) {
      if (this.circleId) {
        reportData({
          type: 3,
          data_type: 2,
          circle_id: this.circleId,
          menu_plate_id: plateId,
          menu_id: item.id
        })
      }
      if (!item.url) {
        return
      }
      if (item.url.includes('?')) {
        try {
          let queryObj = qs.parse(item.url.split('?')[1], { ignoreQueryPrefix: true });
          if (queryObj.circleId == this.circleId) {
            Toast("您已在该圈子中")
            return
          }
        } catch (error) {
          console.log(error);
        }
      }
      this.showSideMenu = false
      if (item.url_type == 2) {
        setTimeout(() => {
          window.location.href = item.url
        }, 10);
        return
      }
      localLinkJump(item.url)
    }
  }
};
</script>

<style lang="scss" module>
.header {
  position: relative;
  z-index: 199;
  width: 100%;
  height: 44px;
  line-height: 44px;
  font-weight: 400;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    font-size: 16px;
  }
  .back {
    width: 40px;
    height: 100%;
    img {
      width: 16px;
      height: 16px;
    }
  }
  .menu {
    position: relative;
    width: 40px;
    height: 100%;
    img {
      position: absolute;
      right: 0px;
      top: 50%;
      transform: translate3d(-3px, -50%, 0);
      height: 16px;
      width: 16px;
    }
    .unread-number {
      position: absolute;
      right: 8px;
      top: 6px;
      width: 20px;
      height: 13px;
      display: inline-block;
      background: rgba(245, 42, 42, 1);
      border-radius: 6px;
      font-size: 8px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 13px;
    }
  }
  .menu-plate {
    width: 175px;
    margin-bottom: 35px;
    .menu-plate-title {
      line-height: 16px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      margin-bottom: 21px;
    }
    .menu-item {
      display: flex;
      margin-bottom: 20px;
      .red-point {
        width: 5px;
        height: 5px;
        background-color: red;
        flex: none;
        position: absolute;
        transform: translate3d(10px, -5px, 0px);
        border-radius: 50%;
      }
      & > img {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        margin-right: 6px;
      }
      & > span {
        font-size: 13px;
        font-weight: 400;
        color: rgba(159, 159, 159, 1);
        line-height: 8px;
        margin-top: 3px;
      }
    }
  }
}
</style>
